/**
 * Hard-coded values for every currently-released
 * cup in Mario Kart 8 Deluxe with their emblems,
 * names, tracks, and game of origin for each track.
 * 
 * @note images for tracks and emblems both come from MK8DX's website 
 * (https://mariokart8.nintendo.com/)
 * 
 * @returns a Map object with cup information.
 */
export default function getCups() {
    return new Map([
        ["mushroom", {
            display: "Mushroom",
            emblem: require("../assets/mk8dx/01_mushroom-emblem.png"),
            tracks: [
                {
                    name: "Mario Kart Stadium",
                    image: require("../assets/mk8dx/01-1_mario-kart-stadium.jpg")
                },
                {
                    name: "Water Park",
                    image: require("../assets/mk8dx/01-2_water-park.jpg")
                },
                {
                    name: "Sweet Sweet Canyon",
                    image: require("../assets/mk8dx/01-3_sweet-sweet-canyon.jpg")
                },
                {
                    name: "Thwomp Ruins",
                    image: require("../assets/mk8dx/01-4_thwomp-ruins.jpg")
                }
            ]
        }],
        ["flower", {
            display: "Flower",
            emblem: require("../assets/mk8dx/02_flower-emblem.png"),
            tracks: [
                {
                    name: "Mario Circuit",
                    image: require("../assets/mk8dx/02-1_mario-circuit.jpg")
                },
                {
                    name: "Toad Harbor",
                    image: require("../assets/mk8dx/02-2_toad-harbor.jpg")
                },
                {
                    name: "Twisted Mansion",
                    image: require("../assets/mk8dx/02-3_twisted-mansion.jpg")
                },
                {
                    name: "Shy Guy Falls",
                    image: require("../assets/mk8dx/02-4_shy-guy-falls.jpg")
                }
            ]
        }],
        ["star", {
            display: "Star",
            emblem: require("../assets/mk8dx/03_star-emblem.png"),
            tracks: [
                {
                    name: "Sunshine Airport",
                    image: require("../assets/mk8dx/03-1_sunshine-airport.jpg")
                },
                {
                    name: "Dolphin Shoals",
                    image: require("../assets/mk8dx/03-2_dolphin-shoals.jpg")
                },
                {
                    name: "Electrodrome",
                    image: require("../assets/mk8dx/03-3_electrodrome.jpg")
                },
                {
                    name: "Mount Wario",
                    image: require("../assets/mk8dx/03-4_mount-wario.jpg")
                }
            ]
        }],
        ["special", {
            display: "Special",
            emblem: require("../assets/mk8dx/04_special-emblem.png"),
            tracks: [
                {
                    name: "Cloudtop Cruise",
                    image: require("../assets/mk8dx/04-1_cloudtop-cruise.jpg")
                },
                {
                    name: "Bone-Dry Dunes",
                    image: require("../assets/mk8dx/04-2_bone-dry-dunes.jpg")
                },
                {
                    name: "Bowser's Castle",
                    image: require("../assets/mk8dx/04-3_bowsers-castle.jpg")
                },
                {
                    name: "Rainbow Road",
                    image: require("../assets/mk8dx/04-4_rainbow-road.jpg")
                }
            ]
        }],
        ["shell", {
            display: "Shell",
            emblem: require("../assets/mk8dx/05_shell-emblem.png"),
            tracks: [
                {
                    name: "Moo Moo Meadows",
                    origin: "Wii",
                    image: require("../assets/mk8dx/05-1_moo-moo-meadows.jpg")
                },
                {
                    name: "Mario Circuit",
                    origin: "GBA",
                    image: require("../assets/mk8dx/05-2_mario-circuit.jpg")
                },
                {
                    name: "Cheep Cheep Beach",
                    origin: "DS",
                    image: require("../assets/mk8dx/05-3_cheep-cheep-beach.jpg")
                },
                {
                    name: "Toad's Turnpike",
                    origin: "N64",
                    image: require("../assets/mk8dx/05-4_toads-turnpike.jpg")
                }
            ]
        }],
        ["banana", {
            display: "Banana",
            emblem: require("../assets/mk8dx/06_banana-emblem.png"),
            tracks: [
                {
                    name: "Dry Dry Desert",
                    origin: "GCN",
                    image: require("../assets/mk8dx/06-1_dry-dry-desert.jpg")
                },
                {
                    name: "Donut Plains 3",
                    origin: "SNES",
                    image: require("../assets/mk8dx/06-2_donut-plains-3.jpg")
                },
                {
                    name: "Royal Raceway",
                    origin: "N64",
                    image: require("../assets/mk8dx/06-3_royal-raceway.jpg")
                },
                {
                    name: "DK Jungle",
                    origin: "3DS",
                    image: require("../assets/mk8dx/06-4_dk-jungle.jpg")
                }
            ]
        }],
        ["leaf", {
            display: "Leaf",
            emblem: require("../assets/mk8dx/07_leaf-emblem.png"),
            tracks: [
                {
                    name: "Wario Stadium",
                    origin: "DS",
                    image: require("../assets/mk8dx/07-1_wario-stadium.jpg")
                },
                {
                    name: "Sherbet Land",
                    origin: "GCN",
                    image: require("../assets/mk8dx/07-2_sherbet-land.jpg")
                },
                {
                    name: "Music Park",
                    origin: "3DS",
                    image: require("../assets/mk8dx/07-3_music-park.jpg")
                },
                {
                    name: "Yoshi Valley",
                    origin: "N64",
                    image: require("../assets/mk8dx/07-4_yoshi-valley.jpg")
                }
            ]
        }],
        ["lightning", {
            display: "Lightning",
            emblem: require("../assets/mk8dx/08_lightning-emblem.png"),
            tracks: [
                {
                    name: "Tick-Tock Clock",
                    origin: "DS",
                    image: require("../assets/mk8dx/08-1_tick-tock-clock.jpg")
                },
                {
                    name: "Piranha Plant Slide",
                    origin: "3DS",
                    image: require("../assets/mk8dx/08-2_piranha-plant-slide.jpg")
                },
                {
                    name: "Grumble Volcano",
                    origin: "Wii",
                    image: require("../assets/mk8dx/08-3_grumble-volcano.jpg")
                },
                {
                    name: "Rainbow Road",
                    origin: "N64",
                    image: require("../assets/mk8dx/08-4_rainbow-road.jpg")
                }
            ]
        }],
        ["egg", {
            display: "Egg",
            emblem: require("../assets/mk8dx/09_egg-emblem.png"),
            tracks: [
                {
                    name: "Yoshi Circuit",
                    origin: "GCN",
                    image: require("../assets/mk8dx/09-1_yoshi-circuit.jpg")
                },
                {
                    name: "Excitebike Arena",
                    image: require("../assets/mk8dx/09-2_excitebike-arena.jpg")
                },
                {
                    name: "Dragon Driftway",
                    image: require("../assets/mk8dx/09-3_dragon-driftway.jpg")
                },
                {
                    name: "Mute City",
                    image: require("../assets/mk8dx/09-4_mute-city.jpg")
                }
            ]
        }],
        ["triforce", {
            display: "Triforce",
            emblem: require("../assets/mk8dx/10_triforce-emblem.png"),
            tracks: [
                {
                    name: "Wario's Gold Mine",
                    origin: "Wii",
                    image: require("../assets/mk8dx/10-1_warios-gold-mine.jpg")
                },
                {
                    name: "Rainbow Road",
                    origin: "SNES",
                    image: require("../assets/mk8dx/10-2_rainbow-road.jpg")
                },
                {
                    name: "Ice Ice Outpost",
                    image: require("../assets/mk8dx/10-3_ice-ice-outpost.jpg")
                },
                {
                    name: "Hyrule Circuit",
                    image: require("../assets/mk8dx/10-4_hyrule-circuit.jpg")
                }
            ]
        }],
        ["crossing", {
            display: "Crossing",
            emblem: require("../assets/mk8dx/11_crossing-emblem.png"),
            tracks: [
                {
                    name: "Baby Park",
                    origin: "GCN",
                    image: require("../assets/mk8dx/11-1_baby-park.jpg")
                },
                {
                    name: "Cheese Land",
                    origin: "GBA",
                    image: require("../assets/mk8dx/11-2_cheese-land.jpg")
                },
                {
                    name: "Wild Woods",
                    image: require("../assets/mk8dx/11-3_wild-woods.jpg")
                },
                {
                    name: "Animal Crossing",
                    image: require("../assets/mk8dx/11-4_animal-crossing.jpg")
                }
            ]
        }],
        ["bell", {
            display: "Bell",
            emblem: require("../assets/mk8dx/12_bell-emblem.png"),
            tracks: [
                {
                    name: "Neo Bowser City",
                    origin: "3DS",
                    image: require("../assets/mk8dx/12-1_neo-bowser-city.jpg")
                },
                {
                    name: "Ribbon Road",
                    origin: "GBA",
                    image: require("../assets/mk8dx/12-2_ribbon-road.jpg")
                },
                {
                    name: "Super Bell Subway",
                    image: require("../assets/mk8dx/12-3_super-bell-subway.jpg")
                },
                {
                    name: "Big Blue",
                    image: require("../assets/mk8dx/12-4_big-blue.jpg")
                }
            ]
        }],
        ["golden-dash", {
            display: "Golden Dash",
            emblem: require("../assets/mk8dx/13_golden-dash-emblem.png"),
            tracks: [
                {
                    name: "Paris Promenade",
                    origin: "Tour",
                    image: require("../assets/mk8dx/13-1_paris-promenade.jpg")
                },
                {
                    name: "Toad Circuit",
                    origin: "3DS",
                    image: require("../assets/mk8dx/13-2_toad-circuit.jpg")
                },
                {
                    name: "Choco Mountain",
                    origin: "N64",
                    image: require("../assets/mk8dx/13-3_choco-mountain.jpg")
                },
                {
                    name: "Coconut Mall",
                    origin: "Wii",
                    image: require("../assets/mk8dx/13-4_coconut-mall.jpg")
                }
            ]
        }],
        ["lucky-cat", {
            display: "Lucky Cat",
            emblem: require("../assets/mk8dx/14_lucky-cat-emblem.png"),
            tracks: [
                {
                    name: "Tokyo Blur",
                    origin: "Tour",
                    image: require("../assets/mk8dx/14-1_tokyo-blur.jpg")
                },
                {
                    name: "Shroom Ridge",
                    origin: "DS",
                    image: require("../assets/mk8dx/14-2_shroom-ridge.jpg")
                },
                {
                    name: "Sky Garden",
                    origin: "GBA",
                    image: require("../assets/mk8dx/14-3_sky-garden.jpg")
                },
                {
                    name: "Ninja Hideaway",
                    image: require("../assets/mk8dx/14-4_ninja-hideaway.jpg")
                }
            ]
        }],
        ["turnip", {
            display: "Turnip",
            emblem: require("../assets/mk8dx/15_turnip-emblem.png"),
            tracks: [
                {
                    name: "New York Minute",
                    origin: "Tour",
                    image: require("../assets/mk8dx/15-1_new-york-minute.jpg")
                },
                {
                    name: "Mario Circuit 3",
                    origin: "SNES",
                    image: require("../assets/mk8dx/15-2_mario-circuit-3.jpg")
                },
                {
                    name: "Kalimari Desert",
                    origin: "N64",
                    image: require("../assets/mk8dx/15-3_kalimari-desert.jpg")
                },
                {
                    name: "Waluigi Pinball",
                    origin: "DS",
                    image: require("../assets/mk8dx/15-4_waluigi-pinball.jpg")
                }
            ]
        }],
        ["propeller", {
            display: "Propeller",
            emblem: require("../assets/mk8dx/16_propeller-emblem.png"),
            tracks: [
                {
                    name: "Sydney Sprint",
                    origin: "Tour",
                    image: require("../assets/mk8dx/16-1_sydney-sprint.jpg")
                },
                {
                    name: "Snow Land",
                    origin: "GBA",
                    image: require("../assets/mk8dx/16-2_snow-land.jpg")
                },
                {
                    name: "Mushroom Gorge",
                    origin: "Wii",
                    image: require("../assets/mk8dx/16-3_mushroom-gorge.jpg")
                },
                {
                    name: "Sky-High Sundae",
                    image: require("../assets/mk8dx/16-4_sky-high-sundae.jpg")
                }
            ]
        }],
        ["rock", {
            display: "Rock",
            emblem: require("../assets/mk8dx/17_rock-emblem.png"),
            tracks: [
                {
                    name: "London Loop",
                    origin: "Tour",
                    image: require("../assets/mk8dx/17-1_london-loop.jpg")
                },
                {
                    name: "Boo Lake",
                    origin: "GBA",
                    image: require("../assets/mk8dx/17-2_boo-lake.jpg")
                },
                {
                    name: "Rock Rock Mountain",
                    origin: "3DS",
                    image: require("../assets/mk8dx/17-3_rock-rock-mountain.jpg")
                },
                {
                    name: "Maple Treeway",
                    origin: "Wii",
                    image: require("../assets/mk8dx/17-4_maple-treeway.jpg")
                }
            ]
        }],
        ["moon", {
            display: "Moon",
            emblem: require("../assets/mk8dx/18_moon-emblem.png"),
            tracks: [
                {
                    name: "Berlin Byways",
                    origin: "Tour",
                    image: require("../assets/mk8dx/18-1_berlin-byways.jpg")
                },
                {
                    name: "Peach Gardens",
                    origin: "DS",
                    image: require("../assets/mk8dx/18-2_peach-gardens.jpg")
                },
                {
                    name: "Merry Mountain",
                    image: require("../assets/mk8dx/18-3_merry-mountain.jpg")
                },
                {
                    name: "Rainbow Road",
                    origin: "3DS",
                    image: require("../assets/mk8dx/18-4_rainbow-road.jpg")
                }
            ]
        }],
        ["fruit", {
            display: "Fruit",
            emblem: require("../assets/mk8dx/19_fruit-emblem.png"),
            tracks: [
                {
                    name: "Amsterdam Drift",
                    origin: "Tour",
                    image: require("../assets/mk8dx/19-1_amsterdam-drift.jpg")
                },
                {
                    name: "Riverside Park",
                    origin: "GBA",
                    image: require("../assets/mk8dx/19-2_riverside-park.jpg")
                },
                {
                    name: "DK Summit",
                    origin: "Wii",
                    image: require("../assets/mk8dx/19-3_dk-summit.jpg")
                },
                {
                    name: "Yoshi's Island",
                    image: require("../assets/mk8dx/19-4_yoshis-island.jpg")
                }
            ]
        }],
        ["boomerang", {
            display: "Boomerang",
            emblem: require("../assets/mk8dx/20_boomerang-emblem.png"),
            tracks: [
                {
                    name: "Bangkok Rush",
                    origin: "Tour",
                    image: require("../assets/mk8dx/20-1_bangkok-rush.jpg")
                },
                {
                    name: "Mario Circuit",
                    origin: "DS",
                    image: require("../assets/mk8dx/20-2_mario-circuit.jpg")
                },
                {
                    name: "Waluigi Stadium",
                    origin: "GCN",
                    image: require("../assets/mk8dx/20-3_waluigi-stadium.jpg")
                },
                {
                    name: "Singapore Speedway",
                    origin: "Tour",
                    image: require("../assets/mk8dx/20-4_singapore-speedway.jpg")
                }
            ]
        }],
        ["feather", {
            display: "Feather",
            emblem: require("../assets/mk8dx/21_feather-emblem.png"),
            tracks: [
                {
                    name: "Athens Dash",
                    origin: "Tour",
                    image: require("../assets/mk8dx/21-1_athens-dash.jpg")
                },
                {
                    name: "Daisy Cruiser",
                    origin: "GCN",
                    image: require("../assets/mk8dx/21-2_daisy-cruiser.jpg")
                },
                {
                    name: "Moonview Highway",
                    origin: "Wii",
                    image: require("../assets/mk8dx/21-3_moonview-highway.jpg")
                },
                {
                    name: "Squeaky Clean Sprint",
                    image: require("../assets/mk8dx/21-4_squeaky-clean-sprint.jpg")
                }
            ]
        }],
        ["cherry", {
            display: "Cherry",
            emblem: require("../assets/mk8dx/22_cherry-emblem.png"),
            tracks: [
                {
                    name: "Los Angeles Laps",
                    origin: "Tour",
                    image: require("../assets/mk8dx/22-1_los-angeles-laps.jpg")
                },
                {
                    name: "Sunset Wilds",
                    origin: "GBA",
                    image: require("../assets/mk8dx/22-2_sunset-wilds.jpg")
                },
                {
                    name: "Koopa Cape",
                    origin: "Wii",
                    image: require("../assets/mk8dx/22-3_koopa-cape.jpg")
                },
                {
                    name: "Vancouver Velocity",
                    origin: "Tour",
                    image: require("../assets/mk8dx/22-4_vancouver-velocity.jpg")
                }
            ]
        }],
        ["acorn", {
            display: "Acorn",
            emblem: require("../assets/mk8dx/23_acorn-emblem.png"),
            tracks: [
                {
                    name: "Rome Avanti",
                    origin: "Tour",
                    image: require("../assets/mk8dx/23-1_rome-avanti.jpg")
                },
                {
                    name: "DK Mountain",
                    origin: "GCN",
                    image: require("../assets/mk8dx/23-2_dk-mountain.jpg")
                },
                {
                    name: "Daisy Circuit",
                    origin: "Wii",
                    image: require("../assets/mk8dx/23-3_daisy-circuit.jpg")
                },
                {
                    name: "Piranha Plant Cove",
                    origin: "",
                    image: require("../assets/mk8dx/23-4_piranha-plant-cove.jpg")
                }
            ]
        }],
        ["spiny", {
            display: "Spiny",
            emblem: require("../assets/mk8dx/24_spiny-emblem.png"),
            tracks: [
                {
                    name: "Madrid Drive",
                    origin: "Tour",
                    image: require("../assets/mk8dx/24-1_madrid-drive.jpg")
                },
                {
                    name: "Rosalina's Ice World",
                    origin: "3DS",
                    image: require("../assets/mk8dx/24-2_rosalinas-ice-world.jpg")
                },
                {
                    name: "Bowser's Castle 3",
                    origin: "SNES",
                    image: require("../assets/mk8dx/24-3_bowsers-castle-3.jpg")
                },
                {
                    name: "Rainbow Road",
                    origin: "Wii",
                    image: require("../assets/mk8dx/24-4_rainbow-road.jpg")
                }
            ]
        }]
    ]);
}